import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 50 51"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#DBEBFF",
      stroke: "#4893F4",
      "stroke-dasharray": "9.46 1.89",
      "stroke-width": "1.646",
      d: "m4.168 42.084 15.523-13.498h24.973L27.79 42.084z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "m4.168 31.284 15.523-13.5h24.973l-16.873 13.5z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#DBEBFF",
      stroke: "#4893F4",
      "stroke-dasharray": "9.46 1.89",
      "stroke-width": "1.646",
      d: "M4.506 21.498 20.029 8h24.973L28.128 21.498z"
    }, null, -1)
  ]))]))
}
export default { render: render }